import {
    CompanyCsSearchResultDto,
    CompanyEntityFilter,
} from '../../api/company/models/companyCs/CompanyCsDtos'
import Section from '../../components/Section'
import CsCompanySearch from '../../uiV2/company/search/CsCompanySearch'

type Props = {
    onSelect?: (company: CompanyCsSearchResultDto) => void
    selectedCompanyId?: string
    syncWithUrl?: boolean
    enforcedCompanyEntityFilter?: Extract<
        CompanyEntityFilter,
        'hasDataProviderId' | 'noDataProviderId'
    >
    sectionSubtitle?: string
}

export default function CompanyColdStorageSearch({
    onSelect,
    selectedCompanyId,
    syncWithUrl = false,
    enforcedCompanyEntityFilter,
    sectionSubtitle = 'Company Cold Storage',
}: Props): React.JSX.Element {
    return (
        <Section subtitle={sectionSubtitle}>
            <CsCompanySearch
                allowEmptyQuery={true}
                minQueryLength={0}
                enableUrlSync={syncWithUrl}
                enforcedCompanyEntityFilter={enforcedCompanyEntityFilter}
                showLogoColumn={true}
                onSelect={onSelect}
                selectedCompanyId={selectedCompanyId}
            />
        </Section>
    )
}
